// extracted by mini-css-extract-plugin
module.exports = {"Login":"Login_Login__BjcTf","form":"Login_form__3gdqk","inputs":"Login_inputs__1f4ky","submit":"Login_submit__3hORH"};